.overflowText {
  max-width: 640px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overrideRow {
  max-height: 88px;
  border: 1px solid #d1d4d6;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overrideRowText {
  display: flex;
  justify-content: space-between;
}

.smartTextRow {
  height: 88px;
  background-color: #ffffff;
  border: 1px solid #d1d4d6;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.smartTextRowText {
  display: flex;
  justify-content: space-between;
}

.whiteRowTop > div:first-of-type {
  max-width: calc(100% - 80px);
}

.smartTextValue {
  composes: overflowText;
  color: #2c2e2f;
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 4px;
}

.smartTextName {
  color: #7a7d81;
  font-size: 13px;
  line-height: 18px;
}

.smartTextRowBottom {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qrCodeBadge {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 4px;
  background-color: #e8f0fe;
  color: #2d70cf;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  flex-shrink: 0;
}

.smartTextRowTextTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pencilIconWrapper {
  cursor: pointer;
  border-radius: 4px;
  margin-right: 12px;
  height: 24px;
  width: 24px;
}

.pencilIconWrapper:hover {
  background: whitesmoke;
}

.trashCanIconWrapper {
  cursor: pointer;
  border-radius: 4px;
  height: 24px;
  width: 24px;
}

.trashCanIconWrapper:hover {
  background: whitesmoke;
}

.rowIcons {
  display: flex;
  justify-content: space-between;
}

/* Mobile smart text row styles - hidden on desktop, shown on mobile */
.mobileSmartTextRow {
  display: none;
  align-items: center;
  width: 100%;
  min-height: var(--mobile-touch-target);
  padding: 12px 0;
  border-bottom: 1px solid #d1d4d6;
  gap: 12px;
}

.mobileSmartTextRow:last-child {
  border-bottom: none;
}

.mobileSmartTextInfo {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mobileSmartTextValue {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: #2c2e2f;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobileSmartTextNameRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobileSmartTextName {
  font-family: Roboto;
  font-size: 12px;
  color: #7a7d81;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobileSmartTextAction {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--mobile-touch-target);
  height: var(--mobile-touch-target);
  border: none;
  background: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  border-radius: 8px;
  padding: 0;
}

.mobileSmartTextAction:active {
  background-color: #f5f5f8;
}

@media (max-width: 640px) {
  .smartTextRow {
    display: none;
  }

  .mobileSmartTextRow {
    display: flex;
  }
}
